import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type EyebrowProps = {
  children: ReactNode;
  icon?: ReactNode;
  tone?: "light" | "dark";
  className?: string;
};

/** Small green section label that sits above every heading. */
export function Eyebrow({ children, icon, tone = "light", className }: EyebrowProps) {
  return (
    <span
      data-eyebrow=""
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-[5px] text-[12.5px] font-medium leading-none tracking-[-0.005em]",
        tone === "light"
          ? "bg-accent-soft text-accent"
          : "bg-white/[0.06] text-white/80 ring-1 ring-inset ring-white/10",
        className,
      )}
    >
      {icon ?? (
        <span
          className={cn(
            "size-1.5 rounded-full",
            tone === "light" ? "bg-accent" : "bg-mint shadow-[0_0_8px_rgba(45,226,208,0.8)]",
          )}
        />
      )}
      {children}
    </span>
  );
}
